export const PRICE_TYPE = {
  AUCTION: 'auction',
  FIXED: 'fixed',
  NEGOTIABLE: 'negotiable',
  ON_REQUEST: 'on-request',
};

export const ERROR_STATUS = {
  NOT_FOUND: 404,
  RATE_LIMIT_EXCEEDED: 429,
  SERVICE_UNAVAILABLE: 503,
};
